<template>
    <div class="container">
        <div class="innovation">
            <div class="card">
                <div class="innovation-content">
                    <h4>去中间化，提高时效性</h4>
                    <p>运用可靠的专业技术，成功解决了链条过长的问题，让生产更接近终端，实现全链路效率与时效的大幅度提升</p>
                </div>
                <div class="innovation-img"><img src="../../images/picture/tctp_bg_1.png"></div>
            </div>
            <div class="card">
                <div class="innovation-content right">
                    <h4>统一存放，盘活渠道库存</h4>
                    <p>通过全面的分析，建立科学合理的统一仓库，实现不同渠道库存共享，可有效降低客户资金占用率及对产品品类的管控</p>
                </div>
                <div class="innovation-img"><img src="../../images/picture/tctp_bg_2.png"></div>
            </div>
            <div class="card float">
                <div class="innovation-content">
                    <h4>资源互通，减少周转与损耗</h4>
                    <p>线上线下资源互通，可减少货物的周转次数和损耗，成本更低，帮助客户实现渠道管理和风险可控</p>
                </div>
                <div class="innovation-img"><img src="../../images/picture/tctp_bg_3.png"></div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.innovation {
    padding-bottom: 1rem;
    .card {
        width: 100%;
        height: 3.54rem;
        margin: 0.6rem 0;
        &:after {
            content: '';
            display: block;
            clear: both;
            visibility: 0;
            height: 0;
        }
        img {
            width: 5.42rem;
        }
    }
    .innovation-content {
        float: left;
        padding: 0.65rem;
        &.right {
                float: right;
            }
        h4 {
            font-size: 30px;
            color: #333333;
            margin: 0.25rem 0;
        }
        p {
            line-height: 1.8em;
            color: #666666;
            margin-bottom: 0.23rem;
            max-width: 4.5rem;
        }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .innovation .innovation-content h4 {
        font-size: 26px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .innovation .innovation-content {
        h4 {
            font-size: 22px;
        }
        p {
            font-size: 12px
        }
    }
}

@media screen and (max-width: 480px) {
    .innovation {
        padding: 0 0 .3rem;
        .card {
            margin: .15rem 0;
            height: auto;
            padding: 0 .15rem;
            box-sizing: border-box;
            .left,
            .right {
                float: none;
            }
        }
        .innovation-content {
            padding: 0;
            h4 {
                font-size: 16px;
                margin: .15rem 0;
                text-align: center;
            }
            p {
                margin-bottom: .15rem;
                font-size: 12px;
                text-align: center;
                color: #999999;
            }
        }
    }
}
</style>
<script>
export default {
    metaInfo: {
        title: '创新价值-安得智联'
    },
    name: 'innovation',
    components: {}
};
</script>